// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"app-components-usersong-pageheader--title","subtitle":"app-components-usersong-pageheader--subtitle"};